import settings from 'config/settings';
import globalSettings from './856';

const configs = {
  856: globalSettings,
};

const {
  appName,
  appContentUrl,
  baseAppId,
  brandName,
  buttonBar,
  buttonRules,
  companyWebsite,
  contact,
  contentKeys,
  defaultAppId,
  demo,
  directoryUrl,
  hasFastTrack,
  imgixUrl,
  instagramHash,
  language,
  languageWarnings,
  name,
  oldAppContentUrl,
  oldImgixUrl,
  piwikSiteid,
  points,
  productLinks,
  sentry,
  sharing,
  social,
  storageKeys,
  userKeys,
} = {
  ...settings,
  baseAppId: 856,
  ...configs[856],
};

export {
  appContentUrl,
  appName,
  baseAppId,
  brandName,
  buttonBar,
  buttonRules,
  companyWebsite,
  contact,
  contentKeys,
  defaultAppId,
  demo,
  directoryUrl,
  hasFastTrack,
  imgixUrl,
  instagramHash,
  language,
  languageWarnings,
  name,
  oldAppContentUrl,
  oldImgixUrl,
  piwikSiteid,
  points,
  productLinks,
  sentry,
  sharing,
  social,
  storageKeys,
  userKeys,
};
